/**
 * The `timelineItemId` query parameter selects one template timeline item
 * on the experience details page, as `<type>-<id>`. Kept free of React and
 * service imports so the issues taxonomy and its tests can share it.
 */
export const TIMELINE_ITEM_QUERY_PARAM = 'timelineItemId';

export const TIMELINE_ITEM_TYPES = ['task', 'msg', 'automation'] as const;

export type TimelineItemType = (typeof TIMELINE_ITEM_TYPES)[number];

/** A template timeline item, keyed the way `timelineItemId` selects one. */
export type TimelineItemRef = { type: TimelineItemType; id: string };

export const toTimelineItemIdParam = (ref: TimelineItemRef): string => `${ref.type}-${ref.id}`;

const TIMELINE_ITEM_ID_PATTERN = new RegExp(`^(${TIMELINE_ITEM_TYPES.join('|')})-(.*)`);

export const parseTimelineItemIdParam = (value: string | null | undefined): TimelineItemRef | null => {
  const match = (value || '').match(TIMELINE_ITEM_ID_PATTERN);
  return match ? { type: match[1] as TimelineItemType, id: match[2] } : null;
};
